const AuthenticationFailedError = function(message, nextState) {
  this.nextState = nextState
  this.message = message
}

AuthenticationFailedError.prototype = Object.create(Error.prototype)
AuthenticationFailedError.prototype.constructor = AuthenticationFailedError

export default AuthenticationFailedError


/** WEBPACK FOOTER **
 ** ./components/identity-provider/authentication-failed-error.js
 **/